import { sendPageView, sendEvent } from "js/utils/google-analytics";

// Send download tracking to GA
export const trackDownload = ({ downloadType, photoId }) => {
    downloadType = downloadType.toLowerCase();
    const pageViewPath = `/download/photo/${downloadType}/${photoId}/`;
    sendPageView(pageViewPath);
    sendEvent("download", "photo", downloadType);
};
